module.exports = __webpack_public_path__ + "img/03.9e77e3b4.png";